export { default } from './ItemResultatTransparencia';
